<div class="sequence-container">
  <div class="sequence-step"></div>
  <div class="sequence-controls">
    <button class="sequence-prev btn btn--tertiary-blue">
      <span class="spinner"></span>
      <span class="label">Back</span>
    </button>
    <button class="sequence-next btn btn--primary-red">
      <span class="spinner"></span>
      <span class="label">Next</span>
    </button>
    <button class="sequence-submit btn btn--primary-red">
      <span class="spinner"></span>
      <span class="label">Submit</span>
    </button>
  </div>
  <div class="sequence-step-footer"></div>
</div>
